import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

const API_URL = import.meta.env.VITE_API_URL || "https://api.lastiqo.com/api";

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [sifre, setSifre] = useState("");
  const [sifreGoster, setSifreGoster] = useState(false);
  const [hata, setHata] = useState("");
  const [yukleniyor, setYukleniyor] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHata("");

    if (!username.trim() || !sifre.trim()) {
      setHata("Kullanıcı adı ve şifre zorunludur.");
      return;
    }

    const payload = {
      username: username.trim(),
      sifre,
    };

    setYukleniyor(true);
    try {
      const res = await fetch(`${API_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      let data = null;
      try {
        data = await res.json();
      } catch {
        // Non-JSON gateway/proxy errors için fallback
      }

      if (!res.ok) {
        setHata(data?.mesaj || `Giriş başarısız (HTTP ${res.status}).`);
        return;
      }

      localStorage.setItem("pl_auth", "1");
      localStorage.setItem("pl_token", data.token);
      localStorage.setItem("pl_kullanici", JSON.stringify(data.kullanici));
      onLogin();
      if (data?.kullanici?.sifreDegistirmeZorunlu) {
        navigate("/zorunlu-sifre", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    } catch {
      setHata("Sunucuya bağlanılamadı. Lütfen tekrar deneyin.");
    } finally {
      setYukleniyor(false);
    }
  };

  return (
    <div className="login-page" style={{ display: "flex", minHeight: "100vh", fontFamily: "'Montserrat', 'Inter', sans-serif" }}>
      {/* Sol — Form */}
      <div
        className="login-panel"
        style={{
          flex: "0 0 480px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: "60px 56px",
          background: "linear-gradient(180deg, #0d1f37 0%, #0a182d 100%)",
          boxShadow: "4px 0 36px rgba(0,0,0,0.28)",
          borderRight: "1px solid rgba(138,203,42,0.2)",
          zIndex: 2,
        }}
      >
        {/* Logo */}
        <div style={{ marginBottom: "48px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div
              style={{
                width: "44px",
                height: "44px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #050a14 55%, #8acb2a)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid rgba(138,203,42,0.55)",
                boxShadow: "0 0 16px rgba(138,203,42,0.35)",
              }}
            >
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="9" stroke="#fff" strokeWidth="1.5" />
                <circle cx="12" cy="12" r="3" fill="#fff" />
                <line x1="12" y1="3" x2="12" y2="7" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                <line x1="12" y1="17" x2="12" y2="21" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                <line x1="3" y1="12" x2="7" y2="12" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                <line x1="17" y1="12" x2="21" y2="12" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </div>
            <div>
              <span style={{ fontSize: "1.5rem", fontWeight: 700, color: "#f7fbff", letterSpacing: "0.4px" }}>
                Lastiqo
              </span>
              <div style={{ fontSize: "0.7rem", color: "#91a8c5", letterSpacing: "1.5px", textTransform: "uppercase", marginTop: "2px" }}>
                Yönetim Paneli
              </div>
            </div>
          </div>
        </div>

        {/* Başlık */}
        <div style={{ marginBottom: "36px" }}>
          <h1 style={{ fontSize: "1.8rem", fontWeight: 800, color: "#f4fbff", marginBottom: "8px" }}>
            Hoş Geldiniz
          </h1>
          <p style={{ color: "#a4b8cf", fontSize: "0.92rem", margin: 0, lineHeight: 1.7 }}>
            Hesabınıza giriş yapın, tüm işlemlerinizi yönetin.
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} autoComplete="off">
          {/* Kullanıcı Adı */}
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", fontSize: "0.82rem", fontWeight: 700, color: "#c8d7e8", marginBottom: "8px", letterSpacing: "0.9px" }}>
              KULLANICI ADI
            </label>
            <div style={{ position: "relative" }}>
              <span style={{ position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)", color: "#88a0bc" }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </span>
              <input
                type="text"
                value={username}
                onChange={(e) => { setUsername(e.target.value); setHata(""); }}
                placeholder="kullaniciadi"
                style={inputStyle(!!hata)}
                onFocus={(e) => e.target.style.borderColor = "#8acb2a"}
                onBlur={(e) => e.target.style.borderColor = hata ? "#dc2626" : "rgba(138,203,42,0.25)"}
              />
            </div>
          </div>

          {/* Şifre */}
          <div style={{ marginBottom: "12px" }}>
            <label style={{ display: "block", fontSize: "0.82rem", fontWeight: 700, color: "#c8d7e8", marginBottom: "8px", letterSpacing: "0.9px" }}>
              ŞİFRE
            </label>
            <div style={{ position: "relative" }}>
              <span style={{ position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)", color: "#88a0bc" }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </span>
              <input
                type={sifreGoster ? "text" : "password"}
                value={sifre}
                onChange={(e) => { setSifre(e.target.value); setHata(""); }}
                placeholder="Şifrenizi girin"
                style={{ ...inputStyle(!!hata), paddingRight: "42px" }}
                onFocus={(e) => e.target.style.borderColor = "#8acb2a"}
                onBlur={(e) => e.target.style.borderColor = hata ? "#dc2626" : "rgba(138,203,42,0.25)"}
              />
              <button
                type="button"
                onClick={() => setSifreGoster(!sifreGoster)}
                style={{ position: "absolute", right: "14px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#88a0bc", padding: 0, display: "flex" }}
              >
                {sifreGoster ? (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* Şifremi Unuttum */}
          <div style={{ textAlign: "right", marginBottom: "20px" }}>
            <Link to="/sifremi-unuttum" style={{ fontSize: "0.82rem", color: "#b7ef4a", textDecoration: "none", fontWeight: 600 }}>
              Şifremi unuttum
            </Link>
          </div>

          {hata && (
            <div style={{
              background: "rgba(220, 38, 38, 0.12)", border: "1px solid rgba(248, 113, 113, 0.45)", borderRadius: "10px",
              padding: "10px 14px", marginBottom: "16px", color: "#fecaca",
              fontSize: "0.85rem", display: "flex", alignItems: "center", gap: "8px",
            }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {hata}
            </div>
          )}

          <button
            type="submit"
            disabled={yukleniyor}
            style={{
              width: "100%", padding: "14px",
              background: yukleniyor ? "#5f8f19" : "linear-gradient(135deg, #b7ef4a, #8acb2a)",
              color: "#fff", border: "none", borderRadius: "8px", fontSize: "1rem",
              fontWeight: 600, cursor: yukleniyor ? "not-allowed" : "pointer",
              letterSpacing: "0.5px", transition: "opacity 0.2s",
              display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
            }}
          >
            {yukleniyor ? (
              <>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ animation: "spin 1s linear infinite" }}>
                  <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                Giriş yapılıyor...
              </>
            ) : "Giriş Yap"}
          </button>
        </form>

        <div style={{ marginTop: "auto", paddingTop: "40px", textAlign: "center", color: "#89a2be", fontSize: "0.78rem" }}>
          © 2026 Lastiqo - Tüm hakları saklıdır.
        </div>
      </div>

      {/* Sağ — Görsel Panel */}
      <div
        className="login-visual"
        style={{
          flex: 1,
          background: "radial-gradient(circle at 18% 20%, rgba(138,203,42,0.2), transparent 34%), radial-gradient(circle at 80% 5%, rgba(93,192,255,0.2), transparent 35%), #050a14",
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          position: "relative", overflow: "hidden", padding: "60px",
        }}
      >
        <div style={{ position: "absolute", inset: 0, backgroundImage: "linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)", backgroundSize: "56px 56px", opacity: 0.1 }} />
        <div style={{ position: "relative", zIndex: 1, marginBottom: "40px", width: "420px", height: "420px", 
          WebkitMaskImage: "radial-gradient(circle closest-side, black 70%, transparent 100%)",
          maskImage: "radial-gradient(circle closest-side, black 70%, transparent 100%)"
        }}>
           <img src="/tire-neon.png" alt="Neon Lastik" style={{ width: "100%", height: "100%", objectFit: "cover", mixBlendMode: "screen", filter: "hue-rotate(58deg) saturate(1.35) contrast(1.2) brightness(1.05)" }} />
        </div>

        <div style={{ textAlign: "center", zIndex: 1, position: "relative" }}>
          <h2 style={{ color: "#fff", fontSize: "2rem", fontWeight: 700, marginBottom: "32px", lineHeight: 1.3 }}>
            Lastik Yönetimini<br /><span style={{ color: "#b7ef4a" }}>Dijitalleştirin</span>
          </h2>
          <div style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap", marginTop: "16px" }}>
            {[{ icon: "🚗", text: "Araç Takip" }, { icon: "🔧", text: "Depo Yönetimi" }, { icon: "📊", text: "Raporlama" }].map((item) => (
              <div key={item.text} style={{
                background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: "30px", padding: "10px 24px", color: "rgba(255,255,255,0.85)",
                fontSize: "0.9rem", display: "flex", alignItems: "center", gap: "8px"
              }}>
                <span style={{ fontSize: "1.1rem" }}>{item.icon}</span><span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @media (max-width: 980px) {
          .login-page {
            display: flex !important;
            flex-direction: column;
            min-height: 100svh !important;
            overflow-y: auto;
            background: #081b31;
          }

          .login-panel {
            flex: 1 1 auto !important;
            width: 100%;
            min-height: 100svh;
            justify-content: flex-start !important;
            padding: 26px 22px 24px !important;
            border-right: none !important;
            box-shadow: none !important;
            overflow-y: auto;
            background:
              linear-gradient(180deg, rgba(13,31,55,0.86) 0%, rgba(5,10,20,0.82) 34%, rgba(10,24,45,0.97) 68%, #0a182d 100%),
              radial-gradient(circle at 50% 24%, rgba(183,239,74,0.22), transparent 34%),
              url("/tire-neon.png") center 108px / min(74vw, 330px) auto no-repeat,
              linear-gradient(180deg, #102437 0%, #050a14 44%, #0a182d 100%) !important;
          }

          .login-panel::before {
            content: "";
            display: block;
            order: 1;
            height: clamp(210px, 38svh, 330px);
            pointer-events: none;
          }

          .login-panel > div:first-child {
            order: 0;
            margin-bottom: 0 !important;
          }

          .login-panel > div:first-child > div {
            gap: 13px !important;
          }

          .login-panel > div:nth-of-type(2) {
            order: 2;
            margin-bottom: 28px !important;
            text-align: center;
          }

          .login-panel > div:nth-of-type(2) h1 {
            margin-bottom: 10px !important;
            font-size: clamp(30px, 8vw, 38px) !important;
          }

          .login-panel > div:nth-of-type(2) p {
            max-width: 360px;
            margin: 0 auto !important;
            font-size: 16px !important;
            line-height: 1.5 !important;
          }

          .login-panel form {
            order: 3;
            width: 100%;
            max-width: 460px;
            margin: 0 auto;
          }

          .login-panel label {
            font-size: 14px !important;
            margin-bottom: 10px !important;
          }

          .login-panel form > div {
            margin-bottom: 22px !important;
          }

          .login-panel input {
            min-height: 56px;
            color: #111827 !important;
            background: #e8f0fb !important;
            border-color: rgba(183,239,74,0.32) !important;
            border-radius: 10px !important;
            font-size: 16px !important;
          }

          .login-panel input:focus {
            border-color: #b7ef4a !important;
            box-shadow: 0 0 0 3px rgba(183,239,74,0.16);
          }

          .login-panel button[type="submit"] {
            min-height: 60px;
            font-size: 18px !important;
          }

          .login-panel > div:last-child {
            order: 4;
            padding-top: 26px !important;
            font-size: 13px !important;
          }

          .login-visual {
            display: none !important;
          }
        }

        @media (max-width: 390px) {
          .login-panel {
            padding-inline: 16px !important;
            background-size: auto, auto, min(78vw, 285px) auto, auto !important;
          }

          .login-panel::before {
            height: 198px;
          }
        }
      `}</style>
    </div>
  );
};

const inputStyle = (hataVar) => ({
  width: "100%",
  padding: "13px 14px 13px 40px",
  border: `1.5px solid ${hataVar ? "#dc2626" : "rgba(138,203,42,0.25)"}`,
  borderRadius: "10px",
  fontSize: "0.92rem",
  color: "#eff6ff",
  outline: "none",
  background: "rgba(5,10,20,0.45)",
  boxSizing: "border-box",
  transition: "border-color 0.2s",
});

export default Login;
